import { BatchEncoderInit } from '../implementation/batch-encoder'
import { CipherTextInit } from '../implementation/cipher-text'
import { CKKSEncoderInit } from '../implementation/ckks-encoder'
import { CoeffModulusInit } from '../implementation/coeff-modulus'
import { ComprModeTypeInit } from '../implementation/compr-mode-type'
import { ContextInit } from '../implementation/context'
import { ContextDataInit } from '../implementation/context-data'
import { DecryptorInit } from '../implementation/decryptor'
import { EncryptionParameterQualifiersInit } from '../implementation/encryption-parameter-qualifiers'
import { EncryptionParametersInit } from '../implementation/encryption-parameters'
import { EncryptorInit } from '../implementation/encryptor'
import { EvaluatorInit } from '../implementation/evaluator'
import { ExceptionInit } from '../implementation/exception'
import { GaloisKeysInit } from '../implementation/galois-keys'
import { KeyGeneratorInit } from '../implementation/key-generator'
import { MemoryPoolHandleInit } from '../implementation/memory-pool-handle'
import { ModulusInit } from '../implementation/modulus'
import { ParmsIdTypeInit } from '../implementation/parms-id-type'
import { PlainModulusInit } from '../implementation/plain-modulus'
import { PlainTextInit } from '../implementation/plain-text'
import { PublicKeyInit } from '../implementation/public-key'
import { RelinKeysInit } from '../implementation/relin-keys'
import { SchemeTypeInit } from '../implementation/scheme-type'
import { SEALConstructor, SEALLibrary } from '../implementation/seal'
import { SecretKeyInit } from '../implementation/secret-key'
import { SecurityLevelInit } from '../implementation/security-level'
import { SerializableInit } from '../implementation/serializable'
import { VectorInit } from '../implementation/vector'
import { Loader } from './loader'

/**
 * Main export for the library
 */
export const SEAL = async (
  Loader: () => Promise<Loader>
): Promise<SEALLibrary> => {
  const loader = await Loader()
  return SEALConstructor({
    BatchEncoder: BatchEncoderInit({
      loader
    }),
    CipherText: CipherTextInit({
      loader
    }),
    CKKSEncoder: CKKSEncoderInit({
      loader
    }),
    CoeffModulus: CoeffModulusInit({
      loader
    }),
    ComprModeType: ComprModeTypeInit({
      loader
    }),
    ContextData: ContextDataInit({
      loader
    }),
    Context: ContextInit({
      loader
    }),
    Decryptor: DecryptorInit({
      loader
    }),
    EncryptionParameterQualifiers: EncryptionParameterQualifiersInit(),
    EncryptionParameters: EncryptionParametersInit({
      loader
    }),
    Encryptor: EncryptorInit({
      loader
    }),
    Evaluator: EvaluatorInit({
      loader
    }),
    Exception: ExceptionInit({
      loader
    }),
    GaloisKeys: GaloisKeysInit({
      loader
    }),
    KeyGenerator: KeyGeneratorInit({
      loader
    }),
    MemoryPoolHandle: MemoryPoolHandleInit({
      loader
    }),
    Modulus: ModulusInit({
      loader
    }),
    ParmsIdType: ParmsIdTypeInit({
      loader
    }),
    PlainText: PlainTextInit({
      loader
    }),
    PlainModulus: PlainModulusInit({
      loader
    }),
    PublicKey: PublicKeyInit({
      loader
    }),
    RelinKeys: RelinKeysInit({
      loader
    }),
    SchemeType: SchemeTypeInit({
      loader
    }),
    SecretKey: SecretKeyInit({
      loader
    }),
    SecurityLevel: SecurityLevelInit({
      loader
    }),
    Serializable: SerializableInit(),
    Vector: VectorInit({
      loader
    })
  })
}
